module.exports = __webpack_public_path__ + "images/emoji/collision.70e6c999a34014795354.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/collision.png
// module id = LuVc
// module chunks = 1